import { render, staticRenderFns } from "./activationRecordDetails.vue?vue&type=template&id=2b659252&scoped=true&"
import script from "./activationRecordDetails.vue?vue&type=script&lang=js&"
export * from "./activationRecordDetails.vue?vue&type=script&lang=js&"
import style0 from "./activationRecordDetails.vue?vue&type=style&index=0&id=2b659252&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b659252",
  null
  
)

export default component.exports